import React, { useEffect, useState } from 'react';
import './MaintenanceUnits.css';
import ManagerSidebar from '../../../components/Sidebar/ManagerSidebar';
import {
  FaHashtag,
  FaInfoCircle,
  FaBuilding,
  FaDollarSign,
  FaHome,
  FaTools,
} from 'react-icons/fa';

function MaintenanceUnits() {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('https://ikaze-thouse-backend.vercel.app/api/v1/appartmentUnits/getAll')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch units');
        }
        return response.json();
      })
      .then(data => {
        console.log('API Response:', data);
        if (!Array.isArray(data.data)) {
          throw new Error('Unexpected data format from API');
        }

        const underMaintenanceUnits = data.data.filter(
          unit => unit.status === 'Maintenance'
        );

        setUnits(underMaintenanceUnits);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setError(err.message || 'Something went wrong');
        setLoading(false);
      });
  }, []);

  return (
    <div className="container">
      
        <ManagerSidebar />
      
      <div className="content">
        <h2>Units Under Maintenance</h2>

        {loading && <p className="status-message">Loading units...</p>}
        {error && <p className="error-message">{error}</p>}
        {!loading && units.length === 0 && (
          <p className="status-message">No units under maintenance.</p>
        )}

        {!loading && units.length > 0 && (
          <div className="card-grid">
            {units.map(unit => (
              <div className="card" key={unit.UnitId}>
                <h3>
                  <FaHome style={{ marginRight: '8px' }} />
                  {unit.unitname}
                </h3>
                <p>
                  <FaHashtag style={{ marginRight: '6px' }} />
                  <strong>ID:</strong> {unit.unitid}
                </p>
                <p>
                  <FaInfoCircle style={{ marginRight: '6px' }} />
                  <strong>Description:</strong> {unit.description}
                </p>
                <p>
                  <FaBuilding style={{ marginRight: '6px' }} />
                  <strong>Floor:</strong> {unit.floornumber}
                </p>
                <p>
                  <FaDollarSign style={{ marginRight: '6px' }} />
                  <strong>Rent:</strong> ${unit.rentamount}
                </p>
                <p>
                  <FaHome style={{ marginRight: '6px' }} />
                  <strong>Type:</strong> {unit.type}
                </p>
                <p>
                  <FaTools style={{ marginRight: '6px' }} />
                  <strong>Status:</strong> {unit.status}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MaintenanceUnits;
